import { render, staticRenderFns } from "./ContentImage.vue?vue&type=template&id=5b38fb21&scoped=true&"
import script from "./ContentImage.vue?vue&type=script&lang=js&"
export * from "./ContentImage.vue?vue&type=script&lang=js&"
import style0 from "./ContentImage.vue?vue&type=style&index=0&id=5b38fb21&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b38fb21",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VImg,VLayout,VTooltip})
